import { createStatusMap } from "@/utils"

/**
 * eBlock 工作状态映射 (1-7)
 */
export const EBlockWorkStatus = {
  0x00: '空状态',
  0x01: '停机',
  0x02: '待机',
  0x03: '充电',
  0x04: '放电',
  0x05: '降额',
  0x06: '告警',
  0x07: '故障',
}

/**
 * eBlock 工作状态颜色映射
 */
export const EBlockStatusColor = {
  1: 'var(--color-stopped)',  // 停机
  2: 'var(--color-standby)',  // 待机
  3: 'var(--color-charging)',  // 充电
  4: 'var(--color-discharge)',  // 放电
  5: 'var(--color-info)',  // 降额
  6: 'var(--color-warning)',  // 告警
  7: 'var(--color-error)'   // 故障
}


export const EblockStatusMap = createStatusMap({
  1: { color: 'var(--color-stopped)', text: '停机' },// 停机
  2: { color: 'var(--color-standby)', text: '待机' },// 待机
  3: { color: 'var(--color-charging)', text: '充电' },// 充电
  4: { color: 'var(--color-discharge)', text: '放电' },// 放电
  5: { color: 'var(--color-info)', text: '降额' },// 降额
  6: { color: 'var(--color-warning)', text: '告警' },// 告警
  7: { color: 'var(--color-error)', text: '故障' },// 故障
})


/**
 * eBlock 工作状态样式类映射
 */
export const EBlockStatusClass = {
  '停机': 'stopped',
  '待机': 'standby',
  '充电': 'charging',
  '放电': 'discharging',
  '降额': 'derate',
  '告警': 'warning',
  '故障': 'fault'
}

/**
 * eLink 运行状态映射 (0-3)
 */
export const ELinkWorkStatus = {
  '1': '停机',
  '2': '待机',
  '3': '充电',
  '4': '放电'
}

/**
 * eLink 运行状态颜色映射
 */
export const ELinkStatusColor = {
  '1': 'var(--color-stopped)', // 停机 - 灰色
  '2': 'var(--color-standby)', // 待机 - 橙色
  '3': 'var(--color-charging)', // 充电 - 绿色
  '4': 'var(--color-discharge)'  // 放电 - 蓝色
}

/**
 * 断路器状态映射
 */
export const AcQfStatus = {
  '0': '断开',
  '1': '闭合'
}

/**
 * 开关状态映射
 */
export const PowerSwitchStatus = {
  '0': '关机',
  '1': '开机'
}

/**
 * 第三方控制使能映射
 */
export const ThirdCtlStatus = {
  '0': '不允许',
  '1': '允许'
}

/**
 * 空调状态映射
 */
export const AircStatus = {
  0: '关机',
  1: '送风',
  2: '制冷',
  3: '加热',
  4: '除湿',
}

/**
 * 消防主机状态映射
 */
export const FireProtectionHostStatus = {
  0x0000: '设备无该配置',
  0x0001: '系统正常',
  0x0002: '系统故障',
  0x0003: '通信故障',
}

/**
 * 消防抑制剂液位状态映射
 */
export const FireLevelStatus = {
  1: '液位正常',
  2: '液位低',
}

/**
 * 消防喷洒状态映射
 */
export const FireSprayStatus = {
  1: '未喷洒',
  2: '已喷洒',
}

/**
 * 状态指标下拉选项
 */
export const StatusIndicatorOptions = ['充放电状态', '功率', '电压', '电流', 'SOC']

/**
 * 格式化数值
 * @param {number} value - 数值
 * @param {number} min - 最小有效位数
 * @param {number} max - 最大有效位数
 * @returns {string} 格式化后的字符串
 */
export const formatNumber = (value, min = 1, max = 2) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '--'
  }
  return Number(value).toFixed(max)
}

/**
 * 格式化状态
 * @param {number} value - 状态值
 * @param {object} statusMap - 状态映射表
 * @returns {string} 状态文本
 */
export const formatStatus = (value, statusMap) => {
  if (value !== undefined && value !== null) {
    return statusMap[value] || '--'
  }
  return '--'
}

/**
 * 获取 eBlock 在线状态文本
 */
export const getEBlockOnlineText = (stateCode) => {
  return (stateCode === 7 || !stateCode) ? '离线' : '在线'
}

/**
 * 获取 eBlock 在线状态样式类
 */
export const getEBlockOnlineClass = (stateCode) => {
  return (stateCode === 7 || !stateCode) ? 'offline' : 'online'
}

/**
 * 根据 SOH 评估健康状态
 * @param {number} soh - SOH 值
 * @returns {string} 健康状态评估
 */
export const appraiseFromSOH = (soh) => {
  if (soh == null || soh === '') return '--'
  const value = Number(soh)
  if (value >= 95) return '极佳'
  if (value >= 90) return '佳'
  if (value >= 80) return '优秀'
  if (value >= 70) return '良好'
  if (value >= 65) return '合格'
  if (value >= 60) return '建议更换'
  return '停止运行'
}



/**
 * 第一列字段配置 (eBlock Detail)
 */
export const column1Fields = [
  { key: 'state_eblock', label: 'eBlock工作状态', unit: '', formatter: (v) => formatStatus(v, EBlockWorkStatus) },
  { key: 'u_cell_max', label: '最高电芯电压', unit: 'mV', formatter: (v) => formatNumber(v) },
  { key: 'temp_cell_max', label: '最高电芯温度', unit: '℃', formatter: (v) => formatNumber(v) },
  { key: 'p_ac', label: 'PCS交流侧有功功率', unit: 'kW', formatter: (v) => formatNumber(v) },
  { key: 'temp_ambient', label: '柜体温度', unit: '℃', formatter: (v) => formatNumber(v) },
  { key: 'pf', label: 'PCS功率因数', unit: '', formatter: (v) => formatNumber(v) },
  { key: 'airc_st', label: '空调状态', unit: '', formatter: (v) => formatStatus(v, AircStatus) },
  { key: 'u_dc', label: '直流电压', unit: 'V', formatter: (v) => formatNumber(v) },
]

/**
 * 第二列字段配置 (eBlock Detail)
 */
export const column2Fields = [
  { key: 'p_charge_upper_limit', label: '允许最大充电功率', unit: 'kW', formatter: (v) => formatNumber(v) },
  { key: 'u_cell_min', label: '最低电芯电压', unit: 'mV', formatter: (v) => formatNumber(v) },
  { key: 'temp_cell_min', label: '最低电芯温度', unit: '℃', formatter: (v) => formatNumber(v) },
  { key: 'q', label: 'PCS交流侧无功功率', unit: 'kVar', formatter: (v) => formatNumber(v) },
  { key: 'hum_ambient', label: '柜体湿度', unit: '%rh', formatter: (v) => formatNumber(v) },
  // { key: 'pf', label: 'PCS功率因数', unit: '', formatter: (v) => formatNumber(v) },
  { key: 'temp_evaporator', label: '空调蒸发器温度', unit: '℃', formatter: (v) => formatNumber(v) },
  { key: 'i_dc', label: '直流电流', unit: 'A', formatter: (v) => formatNumber(v) },
]

/**
 * 第三列字段配置 (eBlock Detail)
 */
export const column3Fields = [
  { key: 'p_discharge_upper_limit', label: '允许最大放电功率', unit: 'kW', formatter: (v) => formatNumber(v) },
  { key: 'u_cell_diff', label: '电芯最高压差', unit: 'mV', formatter: (v) => formatNumber(v) },
  { key: 'temp_cell_diff', label: '电芯最高温差', unit: '℃', formatter: (v) => formatNumber(v) },
  { key: 's', label: 'PCS交流侧视在功率', unit: 'kVA', formatter: (v) => formatNumber(v) },
  // { key: 'temp_ambient', label: '柜体温度', unit: '℃', formatter: (v) => formatNumber(v) },
  // { key: 'pf', label: 'PCS功率因数', unit: '', formatter: (v) => formatNumber(v) },
  { key: 'temp_condenser', label: '空调冷凝器温度', unit: '℃', formatter: (v) => formatNumber(v) },
  { key: 'p_dc', label: '直流功率', unit: 'kW', formatter: (v) => formatNumber(v) },
]

/**
 * 大卡片字段配置
 */
export const mainFields = {
  remainingCapacity: { key: 'e_remain', label: '电池剩余电量', unit: 'kWh', formatter: (v) => formatNumber(v) },
  soc: { key: 'soc', label: '电站SOC', unit: '%', formatter: (v) => formatNumber(v) },
  soh: { key: 'soh', label: '电站SOH', unit: '%', formatter: (v) => appraiseFromSOH(v) },
}

/**
 * 更新列表项数值
 * @param {Array} items - 列表项配置
 * @param {Object} data - API 返回的数据
 * @returns {Array} 更新后的列表项
 */
export const updateColumnItems = (items, data) => {
  if (!data) return items

  // 计算压差和温差
  const enrichedData = {
    ...data,
    u_cell_diff: (data.u_cell_max || 0) - (data.u_cell_min || 0),
    temp_cell_diff: (data.temp_cell_max || 0) - (data.temp_cell_min || 0),
  }

  return items.map(item => ({
    ...item,
    value: item.formatter ? item.formatter(enrichedData[item.key]) : (enrichedData[item.key] || '--')
  }))
}
